<template>
    <div v-if="event && hasPaidTickets" class="row">
        <div class="col col-12">
            <div class="cards-payment">
                <div class="card">
                    <div
                        class="card-header hg-underline"
                        :style="underlineOverride"
                    >
                        Order Summary
                    </div>
                    <div class="card-body">
                        <table class="table" v-for="ticket in tickets">
                            <tr>
                                <td style="padding: 10px 0; font-weight: bold">
                                    {{ ticket.details }}
                                </td>
                                <td
                                    style="
                                        padding: 10px 0;
                                        text-align: right;
                                        color: #00acee;
                                    "
                                >
                                    {{
                                        (discountValid
                                            ? ticket.cost_a
                                            : ticket.cost_b) | currency('£')
                                    }}
                                    ( x {{ ticket.quantity_tickets }} )
                                </td>
                            </tr>
                            <tr v-if="ticket.discount_code_id">
                                <td
                                    v-if="ticket.discount_type == 'percentage'"
                                    style="padding: 10px 0"
                                >
                                    Discount To Deduct:
                                    <small
                                        >({{ ticket.discount_amount }} %)</small
                                    >
                                </td>
                                <td
                                    v-if="ticket.discount_type != 'percentage'"
                                    style="padding: 10px 0"
                                >
                                    Discount To Deduct:
                                    <small
                                        >({{
                                            ticket.discount_amount
                                                | currency('£')
                                        }})</small
                                    >
                                </td>
                                <td
                                    style="
                                        padding: 10px 0;
                                        text-align: right;
                                        color: #00acee;
                                    "
                                >
                                    {{
                                        ticketDiscountAmount(
                                            ticket,
                                            discountValid
                                        ) | currency('£')
                                    }}
                                </td>
                            </tr>
                            <tr v-if="event.vat_exclusive && event.show_vat">
                                <td style="padding: 10px 0">
                                    Vat for Ticket(s)
                                </td>
                                <td
                                    style="
                                        padding: 10px 0;
                                        text-align: right;
                                        color: #00acee;
                                    "
                                >
                                    {{
                                        ticketVatExc(
                                            ticket,
                                            discountValid,
                                            true
                                        ) | currency('£')
                                    }}
                                </td>
                            </tr>
                        </table>

                        <discount-input></discount-input>

                        <div style="margin-top: 15px">
                            <div style="margin-top: 5px">
                                {{
                                    discountCodeId
                                        ? 'Event Cost After Discount'
                                        : 'Event Cost'
                                }}
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{ costNet | currency('£') }}</span
                                >
                            </div>

                            <div
                                style="margin-top: 5px"
                                v-if="vatExclusive"
                                class=""
                            >
                                Total VAT:
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{ totalVat | currency('£') }}</span
                                >
                            </div>

                            <div
                                style="margin-top: 5px"
                                v-if="event.fees_pass_on"
                                class=""
                            >
                                Total Fees:
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{ feesAmount | currency('£') }}
                                </span>
                            </div>

                            <div
                                style="margin-top: 5px"
                                v-if="event.fees_pass_on"
                            >
                                Total to Pay:
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{ totalIncFees | currency('£') }}
                                </span>
                            </div>

                            <div
                                style="margin-top: 5px"
                                v-if="!event.fees_pass_on && vatExclusive"
                            >
                                Total to Pay:
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{
                                        (costNet + totalVat) | currency('£')
                                    }}</span
                                >
                            </div>
                            <hr />
                            <div
                                style="margin-top: 5px"
                                v-if="event.fees_pass_on"
                            >
                                <strong>Note:</strong><br />
                                Payment by International card for the selected
                                tickets will increase the Fee charges to:
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{
                                        feesAmountInternational | currency('£')
                                    }}</span
                                ><br />
                                and total cost to:
                                <span
                                    style="float: right; color: #00acee"
                                    class="amount"
                                    >{{
                                        totalIncFeesInternational
                                            | currency('£')
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" v-if="costNet == undefined || costNet > 0">
                    <div
                        class="card-header hg-underline"
                        :style="underlineOverride"
                    >
                        <div class="">Payment Information</div>
                        <div class="">
                            <b-dropdown
                                right
                                text="Select Payment Method"
                                size="sm"
                                v-if="paymentInfo.bacs || paymentInfo.cheque"
                            >
                                <b-dropdown-item
                                    v-if="paymentInfo.stripe_enabled"
                                    @click="selectPaymentMethod('Card')"
                                    >Credit/Debit Card
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="paymentInfo.cheque"
                                    @click="selectPaymentMethod('Cheque')"
                                    >Cheque
                                </b-dropdown-item>
                                <b-dropdown-item
                                    v-if="paymentInfo.bacs"
                                    @click="selectPaymentMethod('Bacs')"
                                    >Bank Transfer (BACS)
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="paymentMethod == 'Cheque'">
                            <div class="col-12" style="text-align: center">
                                <span class="heading"></span>
                                <h3 style="color: black">Cheque</h3>
                                <p>Cheques should be made out to:</p>
                                <p>
                                    {{ paymentInfo.cheque_payable_name }}
                                </p>
                                <p>And sent to:</p>
                                <p
                                    v-html="paymentInfo.cheque_payable_address"
                                ></p>
                                <p>
                                    For the amount shown on the left side of the
                                    screen
                                </p>
                                <h6 style="color: black">
                                    Click 'Make Payment' below to confirm you
                                    will pay via Cheque.
                                </h6>
                            </div>
                        </div>

                        <div v-if="paymentMethod == 'Bacs'">
                            <div class="col-12">
                                <h3 style="color: black; text-align: center">
                                    Bank Transfer
                                </h3>
                                <p style="color: black; text-align: center">
                                    To make a bank transfer please follow the
                                    instructions in the pro-forma invoice
                                </p>
                                <p style="color: black; text-align: center">
                                    This will be sent as an attachment to your
                                    confirmation email
                                </p>
                                <p style="color: black; text-align: center">
                                    Click 'Make Payment' below to pay via Bank
                                    Transfer
                                </p>
                            </div>
                        </div>

                        <div
                            v-if="
                                paymentMethod == 'Card' &&
                                paymentInfo.stripe_enabled
                            "
                        >
                            <!--              Added token to ensure it is here before doing payments-->
                            <stripe-form v-if="showStripeForm"></stripe-form>
                        </div>
                        <div class="card card-footer">
                            Please note: this form will only be valid for 10
                            minutes. After this time your booking will be
                            cancelled if you have not paid
                        </div>
                    </div>
                </div>
                <div class="card" v-if="costNet != undefined && costNet == 0">
                    <div
                        class="card-header hg-underline"
                        :style="underlineOverride"
                    >
                        <div class="col-8">Payment Information</div>
                    </div>
                    <div class="card-body">
                        <div class="card card-footer">
                            Please note: this discounted booking is now free.
                            Please click confirm booking to complete.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col col-12">
            <div class="card hg-topline" :style="topLineOverride">
                <div class="card-body" align="center">
                    <div class="" style="margin-bottom: 20px">
                        <button
                            v-if="!paymentSubmitted"
                            class="btn btn-primary btn-lg"
                            :style="{
                                'background-color': event.buttoncolour,
                                'border-color': event.buttoncolour,
                            }"
                            @click="makePayment"
                            type="button"
                        >
                            {{ submitBtnText }}
                        </button>
                        <button
                            v-if="paymentSubmitted"
                            class="btn btn-secondary btn-lg"
                            type="button"
                        >
                            <i class="fa fa-spinner fa-spin"></i> Please Wait
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

import hgStripeForm from './hg-stripe-form.vue';
import discountInput from './discount-input.vue';
import costCalcs from '../common/cost-calcs';
import bookingMixin from '../common/booking-mixin';
import PaymentBus from './payment-bus';
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

export default {
    mixins: [costCalcs, bookingMixin],

    beforeRouteLeave(to, from, next) {
        // Prevents going out of payments, stops back button
        if (
            to.name == 'summary' &&
            ((this.paymentMethod == 'Card' && this.paymentStatus == 'paid') ||
                this.paymentMethod != 'Card')
        ) {
            next();
        } else if (to.name == 'summaryfree') {
            next();
        } else {
            next(false);
        }
        next(false);
    },

    data() {
        return {
            showStripeForm: false,
            event: this.$store.getters.getEvent,
            tickets: this.$store.getters.getSelectedTickets,
            eventBooking: this.$store.getters.getEventBooking,

            fees: null,

            advancedUser: window.advanced_user,

            diff: 0,
            paymentMethod: null,
            paymentStatus: null,
            country: 'UK', //Defaults to UK card

            totalVat: 0,
            totalIncFees: 0,
            totalIncFeesInternational: 0,

            //Should be without vat as well
            costNet: null,
            costNetInternational: 0,
            feesAmount: 0,
            feesAmountInternational: 0,

            //TODO needs populating
            vatExclusive: false,

            paymentSubmitted: false,
            // stripeToken: string;

            paymentInfo: {
                stripe_enabled: false,
                bacs: false,
                cheque: false,
                stripe_id: null,
            },

            discountValid: false,
            discountAmount: 0.0,
            discountCodeId: null,
            notificationTimer: null,
            clockTimer: null,
        };
    },

    mounted() {
        var _ithis = this;
        this.paymentMethod = this.$store.getters.getPaymentMethod;
        this.$store.commit('setInProgress', true);
        var t = this.payStart;
        if (!t) {
            this.$store.commit('setPayStart', moment());
        }
        var duration = moment.duration(moment().diff(this.payStart));
        var timeElapsed = duration.asSeconds();
        this.setTimeRemaining(600 - timeElapsed);
        //this.notificationTimer = setInterval(this.timeup, 15000)
        if (
            moment(this.event.datetimeto).isBefore(new Date(), 'day') ||
            this.eventBooking.id == undefined
        ) {
            window.location.href = this.$store.getters.getRefPath;
        }

        if (this.timeRemaining > 0) {
            this.startClock();
        } else {
            this.timeup();
        }

        this.warnTime(t);

        PaymentBus.$on('reEnableButton', () => {
            _ithis.paymentSubmitted = false;
        });

        PaymentBus.$on(
            'getBookingIntent',
            (isEuCard, paymentType, isUpdate) => {
                _ithis.showStripeForm = true;
                _ithis.payBooking(isEuCard, paymentType, isUpdate);
            }
        );

        PaymentBus.$on(
            'completeBooking',
            function (isEuCard, paymentType, stripeToken) {
                _ithis.completeBooking(isEuCard, paymentType, stripeToken);
            }
        );

        if (this.event && this.event.datetime_eb) {
            this.discountValid = moment(this.event.datetime_eb).isAfter(
                new Date()
            );
        }
        this.paymentInfo = this.$store.getters.getPaymentInfo;
        if (_.isEmpty(this.paymentInfo)) {
            this.$http
                .get('/payment_info_for_event/' + this.event.uuid)
                .then(function (response) {
                    _ithis.paymentInfo = response.data.payment_info;
                    console.log(!_ithis.paymentMethod);
                    if (
                        !_ithis.paymentMethod &&
                        !_ithis.paymentInfo.stripe_enabled
                    ) {
                        if (!_ithis.paymentInfo.bacs) {
                            _ithis.paymentMethod = 'Cheque';
                        } else {
                            _ithis.paymentMethod = 'Bacs';
                        }
                    } else {
                        _ithis.paymentMethod = 'Card';
                    }
                    _ithis.$store.commit(
                        'setPaymentMethod',
                        _ithis.paymentMethod
                    );
                    _ithis.$store.commit('setPaymentInfo', _ithis.paymentInfo);
                });
        }
        //      TODO Cannot proceed without this.

        setTimeout(function () {
            var that = _ithis;
            _ithis.$http
                .post('/event_fees/', {
                    event_id: _ithis.event.id,
                    selected_packages: _ithis.tickets,
                })
                .then(
                    function (response) {
                        that.$store.commit(
                            'setBookingToken',
                            response.data.booking_token
                        );
                        that.fees = response.data.fees;
                        that.$store.commit('setFees', _ithis.fees);

                        //    If this was in computed fields we might not need to call this when it changes, e.g discounts
                        that.calcCosts();

                        if (that.paymentMethod == 'Card')
                            PaymentBus.$emit(
                                'getBookingIntent',
                                true,
                                'card',
                                false
                            );
                    },
                    function (response) {
                        that.$message.error('Could not return fee data');
                    }
                );
        }, 500);
    },

    beforeDestroy() {
        this.stopClock();
    },

    computed: {
        ...mapGetters({
            hasPaidTickets: 'getChargeable',
            timeRemaining: 'getTimeRemaining',
            payStart: 'getPayStart',
        }),
        underlineOverride() {
            return {
                borderBottom: '4px solid' + this.event.phcolour,
            };
        },
        topLineOverride() {
            return { borderTop: '4px solid ' + this.event.phcolour };
        },
        submitBtnText() {
            return this.costNet > 0 || this.costNet == undefined
                ? 'Make Payment'
                : 'Confirm Booking';
        },
    },
    methods: {
        completePayment(stuff) {
            // Placeholder
        },

        selectPaymentMethod(paymentMethod) {
            this.$store.commit('setPaymentMethod', paymentMethod);
            this.paymentMethod = paymentMethod;
        },

        makePayment: _.debounce(function () {
            //TODO for make payment, if we have the intent token behave differently

            if (this.paymentSubmitted) {
                return true;
            }
            this.paymentSubmitted = true;

            if (this.costNet != undefined && this.costNet > 0) {
                if (this.paymentMethod == 'Card') {
                    PaymentBus.$emit('payCard');
                } else if (this.paymentMethod == 'Cheque') {
                    this.completeBooking(null, 'cheque', null, null);
                } else {
                    this.completeBooking(null, 'bacs', null, null);
                }
            }

            if (this.costNet != undefined && this.costNet == 0) {
                this.completeBooking(null, 'comp', null, true);
            }
        }, 300),

        timeup() {
            var eventBooking = this.$store.getters.getEventBooking;
            var path = this.$store.getters.getRefPath;
            this.stopClock();
            this.$swal({
                title: 'Your booking has expired.',
                text: 'You must start again if you still wish to book',
                type: 'warning',
                confirmButtonColor: '#FF9500',
            }).then((result) => {
                window.location.href = path;
            });
        },

        stopClock() {
            clearInterval(this.clockTimer);
            this.clockTimer = null;
            this.setTimerDisplay(null);
        },

        startClock() {
            this.clockTimer = setInterval(this.timerTick, 1000);
            this.formatTime();
        },

        timerTick() {
            if (this.timeRemaining > 0) {
                this.setTimeRemaining(this.timeRemaining - 1);
                this.formatTime();
            } else {
                this.timeup();
            }
        },

        formatTime() {
            var hours = Math.floor(this.timeRemaining / 3600);
            var minutes = Math.floor((this.timeRemaining - hours * 3600) / 60);
            var seconds = Math.floor(this.timeRemaining % 60);

            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            this.setTimerDisplay(`${minutes}:${seconds}`);
        },

        calcCosts() {
            //        Todo when is this called could these be computed individually instead.
            if (!this.fees) {
                this.fees = this.$store.getters.getFees;
            }
            this.costNet =
                (this.fees.standard.event_amount -
                    this.fees.standard.total_fees) /
                100;
            this.costNetInternational =
                (this.fees.international.event_amount -
                    this.fees.international.total_fees) /
                100;

            this.feesAmount = this.fees.standard.total_fees / 100;
            this.feesAmountInternational =
                this.fees.international.total_fees / 100;

            this.totalIncFees = this.fees.standard.event_amount / 100;
            this.totalIncFeesInternational =
                this.fees.international.event_amount / 100;

            if (this.event.show_vat && this.event.vat_exclusive) {
                this.vatExclusive = true;
                this.totalVat = this.fees.vat_amount / 100;
                this.costNet = this.costNet - this.totalVat;
            }
        },
        ...mapMutations({
            setTimeRemaining: 'setTimeRemaining',
            setTimerDisplay: 'setTimerDisplay',
        }),
    },

    components: {
        'stripe-form': hgStripeForm,
        'discount-input': discountInput,
    },
};
</script>

<style scoped>
</style>
